export default function HeroSection() {
  return (
    <section className="relative w-full h-[75vh] min-h-[600px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/3d0483f3ebd78d83fddd0f04c2913289.jpg"
        alt="Glen Falls waterfall in Highlands North Carolina surrounded by forest"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/60" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Highlands NC Cabin Guide</p>
        <h1 className="font-cormorant text-5xl md:text-6xl lg:text-7xl text-white font-light leading-tight mb-5 max-w-4xl">
          Cabins Near Glen Falls Waterfall in Highlands, NC
        </h1>
        <p className="text-white/75 font-jost text-sm leading-relaxed max-w-2xl">
          Looking for cabins near Glen Falls waterfall in Highlands, NC? Here are the best places to stay within minutes of one of the most beautiful waterfalls in the Blue Ridge Mountains.
        </p>
      </div>
    </section>
  );
}
